import { RouteConfig } from 'vue-router';

import StartLayout from '@/StartLayout.vue';
import { acceptRoute } from './accept.route';
import { acceptTermsRoute } from './acceptTerms.route';
import { confirmRoute } from './confirm.route';
import { loginRoute } from './login.route';
import { registerRoute } from './register.route';
import { resetPasswordRoute } from './resetPassword.route';
import { setPasswordRoute } from './setPassword.route';

export const startRoute: RouteConfig = {
  path: '',
  component: StartLayout,
  children: [
    loginRoute,
    resetPasswordRoute,
    registerRoute,
    acceptRoute,
    confirmRoute,
    setPasswordRoute,
    acceptTermsRoute
  ],
  redirect: { name: 'login' }
};
